import React from 'react'
import { useLocation } from 'react-router-dom';

function Error() {
    const {error}= useLocation().state;
    return (
        <>
            <div className='w-full h-screen flex items-center justify-center bg-gray-200'>
                <div className='text-xl font-semibold'>{error}</div>
            </div>            
        </>
    )
}

export default Error